export enum CaseStatusFilterOptions {
    None = 1,
    Deleted = 2
}
